module.exports = __webpack_public_path__ + "img/分子研究员.8d9a4299.jpg";